<app-header-cexveg></app-header-cexveg>

<app-spinner [loading]="getLoadingStatus | async"></app-spinner>

<div class="app-body">

  <app-nav-menu></app-nav-menu>

    <main class="main">
        
        <app-breadcrumb-cexveg></app-breadcrumb-cexveg>
        <app-cookiespopup></app-cookiespopup>
        <div>
            <div class="align-self-center">
                <div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>    
        <app-footer-cexveg></app-footer-cexveg>

  </main>

</div>

<p-confirmDialog header="Confirmación" acceptLabel="Sí" modal="true" draggable="true" global="true" appendToBody="true" uiactions=""
    closeOnEscape="true" appendTo="body" rejectLabel="No" icon="fa fa-question-circle" width="425">
</p-confirmDialog>

<app-logout-clave></app-logout-clave>